<template>
  <v-dialog v-model="d" width="60%" persistent>
    <v-card>
      <v-card-title>Manage Customer</v-card-title>
      <v-card-text>
        <v-stepper v-model="e1">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1" editable>Customer</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step :complete="e1 > 2" step="2" editable>Address</v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3" editable>Vehicles</v-stepper-step>
          </v-stepper-header>

          <v-stepper-items>
            <v-stepper-content step="1">
              <v-card class="mb-12 pa-2">
                <v-text-field label="Name" v-model="c.name" color="primary"/>
                <v-text-field label="Company Name" v-model="c.companyName" color="primary"/>
                <v-text-field label="Email" v-model="c.email" color="primary"/>
                <v-text-field label="Phone" v-model="c.phone" color="primary"/>
                <v-text-field label="Mobile" v-model="c.mobile" color="primary"/>
                <v-checkbox label="Has this customer left a review?" v-model="c.hasReviewed" color="primary"/>
                <v-checkbox label="Can a payment be taken automatically?" v-model="c.canTakePayment" color="primary"/>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="2">
              <v-card class="mb-12 pa-2">
                <v-layout>
                  <v-spacer/>
                  <v-btn @click="editAddress =! editAddress" icon color="primary">
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </v-layout>
                <v-autocomplete
                    v-if="editAddress || !c._id"
                    v-model="selectedAddress"
                    :items="addresses"
                    :loading="isLoadingAddress"
                    :search-input.sync="searchAddress"
                    color="primary"
                    hide-no-data
                    item-text="line_1"
                    placeholder="Start typing to Search"
                    return-object
                    clearable
                    no-filter
                    outlined
                    append-icon="mdi-home-search"
                />
                <v-text-field :disabled="!editAddress" label="Address 1" v-model="c.address1" color="primary"/>
                <v-text-field :disabled="!editAddress" label="Address 2" v-model="c.address2" color="primary"/>
                <v-text-field :disabled="!editAddress" label="City" v-model="c.city" color="primary"/>
                <v-text-field :disabled="!editAddress" label="County" v-model="c.county" color="primary"/>
                <v-text-field :disabled="!editAddress" label="Postcode" v-model="c.postcode" color="primary"/>
              </v-card>
            </v-stepper-content>

            <v-stepper-content step="3">
              <v-card class="mb-12 pa-2">
                <v-row>
                  <v-col cols="6">
                    <v-text-field label="Make" v-model="make" color="primary"/>
                    <v-text-field label="Model" v-model="model" color="primary"/>
                    <v-text-field :rules="[v => !!v || 'This field is required']" label="Registration"
                                  v-model="registration" color="primary"/>

                    <v-btn @click="addVehicle" icon small color="success"><v-icon>mdi-plus</v-icon></v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Mileage" v-model="mileage" color="primary"/>
                    <v-text-field label="Color" v-model="colour" color="primary"/>
                    <v-text-field label="Usage" v-model="usage" color="primary"/>
                  </v-col>
                  <v-col cols="12">
                    <v-data-table :loading="isLoading" :headers="headers" :items="vehicles" class="elevation-1 mt-5">
                      <template v-slot:item.registration="{item}">
                        <span v-if="item.registration" class="vrm"> {{ item.registration }} </span><span v-else>N/A</span>
                      </template>
                      <template v-slot:item.actions="{item}">
                        <v-icon color="error" class="mr-2" @click="deleteVehicle(item)">mdi-delete</v-icon>
                      </template>
                    </v-data-table>
                  </v-col>
                </v-row>
              </v-card>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn :loading="isLoading" :disabled="isLoading" text color="primary" @click="closeDialog">Cancel</v-btn>
        <v-btn :loading="isLoading" :disabled="isLoading || vehicles.length === 0" color="primary" @click="saveCustomer">Save
          Customer
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex';
import {AddressHttp} from "@/http/AddressHttp";
import {CustomersHttp} from "@/http/CustomersHttp";
import {XeroHttp} from "@/http/XeroHttp";

export default {
  name: "CustomerModal",
  computed: {
    ...mapState("customers", ["activeCustomer", "manageCustomerDialog"]),
    c: {
      get() {
        return this.activeCustomer;
      }
    },
    d: {
      get() {
        return this.manageCustomerDialog;
      }
    }
  },
  data() {
    return {
      addresses: [],
      isLoadingAddress: false,
      searchAddress: '',
      selectedAddress: {},
      editAddress: false,
      isLoading: false,
      e1: null,
      vehicles: [],
      headers: [
        {text: 'Registration', value: 'registration'},
        {text: 'Make', value: 'make'},
        {text: 'Model', value: 'model'},
        {text: 'Colour', value: 'colour'},
        {text: 'Usage', value: 'usage'},
        {text: 'Mileage', value: 'mileage'},
        {text: 'Actions', value: 'actions', sortable: false}
      ],
      make: null,
      model: null,
      registration: null,
      usage: null,
      colour: null,
      mileage: null
    }
  },
  methods: {
    ...mapActions("customers", ["setActiveCustomer", "setManageCustomerDialog"]),
    ...mapMutations("app", ["setToast"]),
    async closeDialog() {
      this.vehicles = [];
      this.make = null;
      this.model = null;
      this.mileage = null;
      this.colour = null;
      this.usage = null;
      this.registration = null;
      await this.setActiveCustomer({});
      await this.setManageCustomerDialog(false);
    },
    deleteVehicle(item) {
      const index = this.vehicles.findIndex(x => x.registration === item.registration);
      this.vehicles.splice(index, 1);
    },
    addVehicle() {
      this.vehicles.push({
        make: this.make,
        model: this.model,
        mileage: this.mileage,
        colour: this.colour,
        usage: this.usage,
        registration: this.registration
      })
    },
    async saveCustomer() {
      try {
        this.isLoading = true;
        const c = {...this.c}
        c.email = c.email.trim();
        c.vehicles = this.vehicles;
        if (c._id) {
          await CustomersHttp.updateCustomer(c);
          await XeroHttp.updateCustomer(c);
        } else {
          await CustomersHttp.createCustomer(c);
          await XeroHttp.createCustomer(c);
        }
        this.setToast({color: 'success', text: 'Customer saved successfully', show: true});
        this.vehicles = [];
        await this.setActiveCustomer({});
        await this.setManageCustomerDialog(false);
      } catch (err) {
        this.setToast({color: 'error', text: err.response.data, show: true})
      } finally {
        this.isLoading = false;
      }
    }
  },
  watch: {
    c: {
      handler(newVal) {
        if (!newVal.companyName) {
          newVal.companyName = newVal.name;
        }
        if (newVal.vehicles) {
          this.vehicles = newVal.vehicles;
        }
      },
      deep: true,
      immediate: true
    },
    selectedAddress: {
      handler(newVal) {
        if (newVal && this.c) {
          this.c.address1 = newVal.line_1;
          this.c.address2 = newVal.line_2;
          this.c.county = newVal.county;
          this.c.postcode = newVal.postcode;
          this.c.city = newVal.post_town;
        }
      },
      deep: true,
      immediate: true
    },
    async searchAddress(val) {
      if (val && val.length < 5) return;
      if (val) {
        this.isLoadingAddress = true;
        try {
          this.addresses = await AddressHttp.fetchAddresses(val).then(result => result.data);
        } catch (e) {
          alert(e);
        } finally {
          this.isLoadingAddress = false;
        }
      }
    },
  }
}
</script>

<style scoped>

</style>
